import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createRecaptcha(
  type: EntityTypeEnum.OptInRecaptcha | EntityTypeEnum.ContactUsRecaptcha,
  parentId: string,
  masterBlockId?: MasterBlockId,
): RecaptchaInterface {
  const recaptcha: RecaptchaInterface = {
    id: generateId(),
    type: type,
    parentId: parentId,
    masterBlockId: masterBlockId,
    slug: FieldSlugEnum.Recaptcha,
    theme: 'light',
    alignSelf: 'flex-start',
    appearance: {
      desktop: true,
      mobile: true,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    htmlAttrId: generateHtmlAttrId(type),
  }

  return recaptcha
}
